import React, { memo, ReactNode } from 'react';
import { View } from 'react-native';

import { styles } from './styles';

export const FocusableHighlightBottom = memo<FocusableHighlightBottomProps>(({ isFocused, node }) => (
  <View>
    {node}
    {isFocused && <View style={styles.focusBar} />}
  </View>
));

type FocusableHighlightBottomProps = {
  node?: ReactNode;
  isFocused: boolean;
};
